// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rolledOver * {\n  animation-name: rollover;\n  animation-duration: 500ms;\n  animation-timing-function: ease-out;\n}\n@keyframes rollover {\n0% {\n    color: red;\n}\n10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n}\n20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n}\n30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n}\n40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n}\n100% {\n    color: inherit;\n}\n}\n", ""]);
// Exports
module.exports = exports;
